import { useEffect } from 'react';

import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import config from '@config';
import { TimelyProvider } from '@ditto-insurance/react-timely';
import 'url-search-params-polyfill';
import Routes from '@routes';
import { Robots } from '@seo';
import { storeAppParams } from '@services/storage';
import { REFERRER_COOKIE_NAME, REFERRER_PARAM_NAME } from '@utils/constants';

const App: React.FC<any> = (props) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const referrerCode = urlParams.get(REFERRER_PARAM_NAME);
      if (referrerCode) {
        document.cookie = `${REFERRER_COOKIE_NAME}=${referrerCode};max-age=${
          7 * 24 * 60 * 60
        };path=/;${config.COOKIE_DOMAIN ? `domain=${config.COOKIE_DOMAIN};` : ''}`;
      }
      // inject params to app using url params
      storeAppParams(urlParams);
    }
  }, []);

  return (
    <BrowserRouter>
      <HelmetProvider>
        <TimelyProvider {...props}>
          <Robots />
          <Routes />
        </TimelyProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
};

export default App;
